import React from 'react';
import dataAids from '../../../../constants/dataAids';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import { errorMessageProps } from '../../../../constants/constants';

const InventoryWarning = props => {
  const {
    product,
    translate,
    priceTable,
    selectedVariant,
    productErrorMessages,
    isSelectedVariantInStock
  } = props;
  const { Block } = UX2.Element;

  if (!product || !product.track_inventory || product.backorderable) {
    return null;
  }

  const variantData = priceTable[selectedVariant] || {};
  const quantityErrors = productErrorMessages('quantity');

  if (quantityErrors.length) {
    return <Block { ...errorMessageProps } children={ quantityErrors[0] } />;
  } else if (!isSelectedVariantInStock) {
    return (
      <Block
        { ...errorMessageProps }
        data-aid={ dataAids.OUT_OF_STOCK }
        children={ translate('products.item_out_of_stock_v2') }
      />
    );
  } else if (variantData.totalOnHand <= 3) {
    let quantityWarningText = translate('products.item_low_quantity_singular');
    if (variantData.totalOnHand > 1) {
      quantityWarningText = translate('products.item_low_quantity_plural', {
        count: variantData.totalOnHand
      });
    }
    return (
      <Block
        { ...errorMessageProps }
        data-aid={ dataAids.LOW_INVENTORY_ALERT_RENDERED }
        children={ quantityWarningText }
      />
    );
  }

  return null;
};

InventoryWarning.propTypes = {
  product: PropTypes.object,
  translate: PropTypes.func,
  priceTable: PropTypes.object,
  selectedVariant: PropTypes.number,
  productErrorMessages: PropTypes.func,
  isSelectedVariantInStock: PropTypes.bool
};

export default InventoryWarning;
